import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import { Link, routerStore } from 'core/routing';
import { useClientStore } from 'apps/hooks';
import { OpenTab } from 'libs/gutClient/electronBridge';

const StyledLink = styled(Link)`
  color: ${props => props.theme.color.wfBlack};
  &:hover {
    color: ${props => props.theme.color.wfBlue};
  }
`;

type PropsT = {
  name: string;
  params: object;
  target?: string;
  onClick?: () => void;
  children: React.ReactNode;
  openTab?: OpenTab;
  dataTestId?: string;
};

export const PortalLink = observer(
  ({
    name: nameProp,
    params,
    children,
    onClick,
    target,
    openTab,
    dataTestId,
  }: PropsT) => {
    let name = nameProp;
    const clientStore = useClientStore();
    let affix = null;
    if (clientStore.currentPortal === 'INTERMEDIATOR') {
      affix = 'intermediator';
    } else if (clientStore.currentPortal === 'MANUFACTURER') {
      affix = 'manufacturer';
    }
    if (affix) {
      let portalName = '';
      if (name.startsWith('workspace')) {
        portalName = name.replace('workspace', `workspace.${affix}`);
      } else {
        portalName = [affix, name].join('.');
      }

      try {
        // check that the route we constructed with `<route>.intermediator` (or similar) actually exists
        // otherwise just do not append the affix.
        routerStore.router.buildUrl(portalName, params);
        name = portalName;
      } catch (err) {
        // This is fine, just tried to make a Portal link with target a route that does not support
        // the "intermediator" mode.
      }
    }
    return (
      <StyledLink
        openTab={openTab}
        name={name}
        params={params}
        onClick={onClick}
        target={target}
        dataTestId={dataTestId}
      >
        {children}
      </StyledLink>
    );
  },
);
